"use client";
import Image from "next/image";
import {AspectRatio, Stack, Heading, SimpleGrid, Text} from "@chakra-ui/react";
import {useSectionHeadingVariant} from "@/theme/components/useSectionHeading";
import {TECH_STACK_CONSTANTS, OUR_PARTNERS} from "./constants";

const TechStack = () => {
  const HeadingVariant = useSectionHeadingVariant();
  const {title, subTitle, concText, bgImage} = TECH_STACK_CONSTANTS;
  return (
    <Stack
      spacing={4}
      backgroundImage={bgImage.src}
      backgroundPosition={"center"}
      backgroundSize={"cover"}
      borderRadius={"20px"}
      py={8}
    >
      <Heading variant={HeadingVariant} textAlign={"center"} px={2} color="white">
        {title}
      </Heading>
      <Text
        fontSize={{base: "16px", md: "20px"}}
        fontStyle={"italic"}
        color="white"
        textAlign={"center"}
        px={2}
      >
        {subTitle}
      </Text>
      <SimpleGrid
        columns={{base: 4, xl: 8}}
        columnGap={{base: 3, xl: 6}}
        justifyContent={"center"}
        alignItems={"center"}
        rowGap={6}
        px={3}
        py={8}
      >
        {OUR_PARTNERS.map((stack, index) => {
          return (
            <AspectRatio ratio={2 / 1} key={index} position="relative" maxH="90px" px={1}>
              <Image
                src={stack.logo}
                alt={stack.name}
                fill
                style={{
                  objectFit: "contain",
                  objectPosition: "center",
                }}
              />
            </AspectRatio>
          );
        })}
      </SimpleGrid>
      <Text
        fontSize={{base: "16px", md: "20px"}}
        color="white"
        textAlign={"center"}
        px={2}
        lineHeight={{base: "24px", md: "30px"}}
      >
        {concText}
      </Text>
    </Stack>
  );
};

export default TechStack;
